module.exports = __webpack_public_path__ + "static/media/more-options.aeb3c29b.svg";